import { useAuth } from '@clerk/clerk-react';

/**
 * Получает JWT токен с email template
 */
export async function getAuthToken(getToken: (opts?: { template?: string }) => Promise<string | null>): Promise<string | null> {
  try {
    // Используем кастомный JWT template с email
    const token = await getToken({ template: 'withmail' });
    return token;
  } catch (error) {
    return null;
  }
}

/**
 * Hook для получения заголовков авторизации с JWT токеном (включая email)
 */
export function useAuthHeaders() {
  const { getToken } = useAuth();
  
  const getAuthHeaders = async (): Promise<HeadersInit> => {
    try {
      const token = await getAuthToken(getToken);
      
      if (token) {
        return {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        };
      }
    } catch (error) {
    }
    
    return {
      'Content-Type': 'application/json'
    };
  };
  
  return { getAuthHeaders };
}

/**
 * Функция для получения заголовков авторизации (для использования вне компонентов)
 * Требует передачи функции getToken
 */
export async function createAuthHeaders(
  getToken: (opts?: { template?: string }) => Promise<string | null>,
  additionalHeaders?: HeadersInit
): Promise<HeadersInit> {
  try {
    const token = await getAuthToken(getToken);
    
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };
    
    // Merge additional headers if provided
    if (additionalHeaders) {
      Object.entries(additionalHeaders).forEach(([key, value]) => {
        if (typeof value === 'string' || typeof value === 'number') {
          headers[key] = String(value); // Convert to string
        }
      });
    }
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    return headers;
  } catch (error) {
    console.error('Error getting auth headers:', error);
    const fallbackHeaders: Record<string, string> = {
      'Content-Type': 'application/json'
    };
    
    // Merge additional headers if provided
    if (additionalHeaders) {
      Object.entries(additionalHeaders).forEach(([key, value]) => {
        if (typeof value === 'string' || typeof value === 'number') {
          fallbackHeaders[key] = String(value); // Convert to string
        }
      });
    }
    
    return fallbackHeaders;
  }
}